export default "__VITE_ASSET__BJ45iBba__"